import React, { useState } from 'react';
import { ExternalLink } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const CropLoanWaiver = () => {
  const { language } = useLanguage();
  const [activeTab, setActiveTab] = useState('before');

  const content = {
    en: {
      title: 'Crop Loan Waiver - 2026',
      before: 'Regionwise Crop Loan Waiver - Before TNeGA Scrutinization',
      after: 'Regionwise Crop Loan Waiver - After TNeGA Scrutinization',
      note: 'Details will be updated shortly.',
      sno: 'S.No',
      district: 'District',
      document: 'Document',
    },
    ta: {
      title: 'பயிர் கடன் தள்ளுபடி - 2026',
      before: 'TNeGA ஆய்வுக்கு முந்தைய மண்டல வாரியான கடன் விவரங்கள்',
      after: 'TNeGA ஆய்வுக்குப் பிந்தைய மண்டல வாரியான கடன் விவரங்கள்',
      note: 'விவரங்கள் விரைவில் புதுப்பிக்கப்படும்.',
      sno: 'வ.எண்',
      district: 'மாவட்டம்',
      document: 'ஆவணம்',
    },
  };

  const t = content[language];

  // Single district list — used for both before and after tabs
  const districts = [
    { name_en: 'Ariyalur',        name_ta: 'அரியலூர்',       file: 'Ariyalur.pdf' },
    { name_en: 'Chengalpattu',    name_ta: 'செங்கல்பட்டு',   file: 'Chengalpattu.pdf' },
    { name_en: 'Coimbatore',      name_ta: 'கோயம்புத்தூர்',   file: 'Coimbatore.pdf' },
    { name_en: 'Cuddalore',       name_ta: 'கடலூர்',         file: 'Cuddalore.pdf' },
    { name_en: 'Dharmapuri',      name_ta: 'தர்மபுரி',       file: 'Dharmapuri.pdf' },
    { name_en: 'Dindigul',        name_ta: 'திண்டுக்கல்',    file: 'Dindigul.pdf' },
    { name_en: 'Erode',           name_ta: 'ஈரோடு',         file: 'Erode.pdf' },
    { name_en: 'Kallakurichi',    name_ta: 'கள்ளக்குறிச்சி', file: 'Kallakurichi.pdf' },
    { name_en: 'Kancheepuram',    name_ta: 'காஞ்சிபுரம்',   file: 'Kancheepuram.pdf' },
    { name_en: 'Kanyakumari',     name_ta: 'கன்னியாகுமரி',   file: 'Kanyakumari.pdf' },
    { name_en: 'Karur',           name_ta: 'கரூர்',         file: 'Karur.pdf' },
    { name_en: 'Krishnagiri',     name_ta: 'கிருஷ்ணகிரி',   file: 'Krishnagiri.pdf' },
    { name_en: 'Madurai',         name_ta: 'மதுரை',         file: 'Madurai.pdf' },
    { name_en: 'Mayiladuthurai',  name_ta: 'மயிலாடுதுறை',   file: 'Mayiladuthurai.pdf' },
    { name_en: 'Nagapattinam',    name_ta: 'நாகப்பட்டினம்', file: 'Nagapattinam.pdf' },
    { name_en: 'Namakkal',        name_ta: 'நாமக்கல்',      file: 'Namakkal.pdf' },
    { name_en: 'Nilgiris',        name_ta: 'நீலகிரி',       file: 'Nilgiris.pdf', after_file: 'Nilgiri.pdf' },
    { name_en: 'Perambalur',      name_ta: 'பெரம்பலூர்',    file: 'Perambalur.pdf' },
    { name_en: 'Pudukkottai',     name_ta: 'புதுக்கோட்டை', file: 'Pudukkottai.pdf' },
    { name_en: 'Ramanathapuram',  name_ta: 'இராமநாதபுரம்',  file: 'Ramanathapuram.pdf' },
    { name_en: 'Ranipet',         name_ta: 'ராணிப்பேட்டை',  file: 'Ranipet.pdf' },
    { name_en: 'Salem',           name_ta: 'சேலம்',         file: 'Salem.pdf' },
    { name_en: 'Sivagangai',      name_ta: 'சிவகங்கை',      file: 'Sivagangai.pdf' },
    { name_en: 'Tenkasi',         name_ta: 'தென்காசி',      file: 'Tenkasi.pdf' },
    { name_en: 'Thanjavur',       name_ta: 'தஞ்சாவூர்',     file: 'Thanjavur.pdf' },
    { name_en: 'Theni',           name_ta: 'தேனி',          file: 'Theni.pdf' },
    { name_en: 'Thoothukudi',     name_ta: 'தூத்துக்குடி',  file: 'Thoothukudi.pdf' },
    { name_en: 'Tiruchirappalli', name_ta: 'திருச்சிராப்பள்ளி', file: 'Tiruchirappalli.pdf' },
    { name_en: 'Tirunelveli',     name_ta: 'திருநெல்வேலி',   file: 'Tirunelveli.pdf' },
    { name_en: 'Tirupattur',      name_ta: 'திருப்பத்தூர்', file: 'Tirupattur.pdf' },
    { name_en: 'Tiruppur',        name_ta: 'திருப்பூர்',    file: 'Tiruppur.pdf' },
    { name_en: 'Thiruvallur',     name_ta: 'திருவள்ளூர்',   file: 'Thiruvallur.pdf' },
    { name_en: 'Thiruvannamalai', name_ta: 'திருவண்ணாமலை',  file: 'Thiruvannamalai.pdf' },
    { name_en: 'Thiruvarur',      name_ta: 'திருவாரூர்',    file: 'Thiruvarur.pdf' },
    { name_en: 'Vellore',         name_ta: 'வேலூர்',         file: 'Vellore.pdf' },
    { name_en: 'Villupuram',      name_ta: 'விழுப்புரம்',   file: 'Villupuram.pdf' },
    { name_en: 'Virudhunagar',    name_ta: 'விருதுநகர்',    file: 'Virudhunagar.pdf' },
  ];

  const folder = activeTab === 'before'
    ? '/documents/crop-loan-waiver-before'
    : '/documents/crop-loan-waiver-after';

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-50 to-blue-100 border-b border-blue-200">
        <div className="mx-auto px-4 py-8 max-w-5xl">
          <h1 className="text-2xl md:text-3xl font-bold text-gray-800 text-center">{t.title}</h1>
        </div>
      </div>

      <div className="mx-auto px-4 py-8 max-w-4xl">
        {/* Tabs */}
        <div className="flex flex-col sm:flex-row gap-1 mb-8 border-b border-gray-200">
          <button
            onClick={() => setActiveTab('before')}
            className={`px-5 py-3 font-semibold text-sm transition-all duration-200 border-b-2 text-left ${
              activeTab === 'before'
                ? 'border-blue-600 text-blue-600'
                : 'border-transparent text-gray-600 hover:text-gray-900'
            }`}
          >
            {t.before}
          </button>
          <button
            onClick={() => setActiveTab('after')}
            className={`px-5 py-3 font-semibold text-sm transition-all duration-200 border-b-2 text-left ${
              activeTab === 'after'
                ? 'border-blue-600 text-blue-600'
                : 'border-transparent text-gray-600 hover:text-gray-900'
            }`}
          >
            {t.after}
          </button>
        </div>

        {/* District Table */}
        <div className="bg-white shadow-sm rounded-lg border border-gray-200 overflow-hidden">
          <table className="w-full">
            <thead className="bg-blue-600 text-white">
              <tr>
                <th className="px-4 py-3 text-center font-semibold text-sm w-20">{t.sno}</th>
                <th className="px-4 py-3 text-left font-semibold text-sm">{t.district}</th>
              </tr>
            </thead>
            <tbody>
              {districts.map((d, index) => (
                <tr key={index} className={`${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'} hover:bg-blue-50 transition-colors border-t border-gray-100`}>
                  <td className="px-4 py-2.5 text-sm text-gray-600 text-center font-medium">
                    {index + 1}
                  </td>
                  <td className="px-4 py-2.5 text-sm">
                    <a
                      href={`${folder}/${activeTab === 'after' && d.after_file ? d.after_file : d.file}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 hover:text-blue-800 hover:underline font-medium inline-flex items-center gap-1.5"
                    >
                      {language === 'en' ? d.name_en : d.name_ta}
                      <ExternalLink className="w-3.5 h-3.5 shrink-0 opacity-70" />
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default CropLoanWaiver;
